export class AdvertisementSettingsDto  {
    timestampFacebookMarketingUpdated!: Date;
}